import { SubscriptionType } from './plan.types';

export enum SubscriptionOfferStatus {
  ACTIVE = 'active',
  INCOMPLETE = 'incomplete',
}

export enum OfferSortBy {
  COMPANY_NAME = 'companyName',
  PLAN_TYPE = 'planType',
  RECIPIENTS = 'recipients',
  STAKEHOLDERS_LIMIT = 'stakeholdersLimit',
}

export type SubscriptionOffer = {
  companyDomain: string;
  companyName: string;
  createdAt: string;
  currency: string;
  docusignEnvelopeLimit: null | number;
  id: string;
  isMonthlyEnabled: boolean;
  link: string;
  monthlyPriceInCents: null | number;
  planType: SubscriptionType;
  promoCode: null | string;
  recipients: string[];
  slug: string;
  stakeholdersLimit: number;
  status: SubscriptionOfferStatus;
  yearlyPriceInCents: number;
};
